import { FontIcon, IFontIconStyles, ITheme, useTheme } from "@bps/fluent-ui";

interface DotFontIconProps {
  iconStyles?: IFontIconStyles;
}

const getDotFontIconStyles = (theme: ITheme, iconStyles?: IFontIconStyles) => ({
  root: {
    fontSize: 8,
    color: theme.semanticColors.successIcon,
    alignSelf: "center",
    paddingRight: 6,
    ...iconStyles?.root
  }
});

export const DotFontIcon = ({ iconStyles }: DotFontIconProps) => {
  const theme = useTheme();

  return (
    <FontIcon
      iconName="CircleFill"
      styles={getDotFontIconStyles(theme, iconStyles)}
    />
  );
};
